import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router/router'
import store from './store'
import './plugins/vant.js'
import './router/index'
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.filter('dateFormat',function(input,fmtstring){
  return moment(input).format(fmtstring)
})
